<template>
  <div class="mx-4">
    <validation-observer ref="paymentRelationshipForm" novalidate tag="form">
      <div class="row mb-3 pt-3">
        <div class="col-md-12">
          <icon-view
            icon="fa fa-user-edit"
            icon-background="#fff"
            icon-color="#FF7058"
            icon-size="15px"
            title="Búsqueda de Relación de Pago"
            variant="custom-icon-view"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm-12">
          <custom-drop-down
            v-model="filter.reasonType"
            class="custom-drop-down relation-field"
            :clearable="false"
            fieldkey="id"
            fieldname="name"
            :options="relationTypes"
            placeholder="Seleccione"
          />
        </div>
        <div v-if="showFilter" class="col-md-3 col-sm-12 mt-2 mt-md-0 mt-sm-2">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="filter.sieOrSsn"
              class="w-100 sie-field"
              custom-error-msg="Debe Escribir Número de SIE o SSN"
              :error="errors[0]"
              icon="fa fa-search color-orange"
              left-icon
              placeholder="Escribir Número de SIE o SSN"
            />
          </validation-provider>
        </div>
        <div
          class="col-md-3 col-sm-12 mt-2 mt-md-0 mt-sm-2 d-flex align-items-start justify-content-md-start justify-content-sm-end"
        >
          <action-button
            i="fa fa-search"
            variant="success px-3"
            @click="searchHandler"
          >
            Buscar
          </action-button>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12 pb-5">
          <board
            v-if="result.studentInfo && result.services.length > 0"
            class="my-4"
            :details="studentBoardData"
          />

          <custom-separator class="my-5" text="Resultado de Búsqueda" />

          <custom-result-not-found v-if="result.services.length === 0" />

          <div v-if="result.services.length > 0">
            <div class="row">
              <div
                v-for="(item, index) in result.services"
                :key="`item-service-${index}`"
                class="col-3 mb-3"
              >
                <custom-checkbox-single-option
                  ref="customCheckboxRef"
                  v-model="item.selected"
                  class="custom-single-option"
                  :option-text="serviceDescription(item.serviceDescription)"
                  @input="onSelectServiceHandler(item, index)"
                />
              </div>
            </div>
            <div class="row mt-4 mt-md-0 mt-sm-3 pb-3">
              <div
                class="col-12 d-flex align-items-center justify-content-md-end justify-content-sm-none"
              >
                <action-button
                  i="fas fa-times-circle"
                  variant="outline-danger btn-cancel danger px-3 mr-2"
                  @click="onCancel()"
                >
                  Cancelar
                </action-button>
                <action-button
                  i="fas fa-save"
                  variant="success px-3"
                  @click="onSave()"
                >
                  Guardar
                </action-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>
<script>
import IconView from 'icon-view';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import CustomInput from 'CustomInput';
import CustomCheckboxSingleOption from 'custom-checkbox-single-option';
import Board from 'Board';
import alertMixin from 'utils/mixins/alert.mixin';
import relatedPaymentReasonTypes from '@/utils/constants/relatedPaymentReasonTypes.js';
import serviceTypeEnum from '@/views/scholarship/attendance/utils/serviceTypeEnum.js';

import {
  getPaymentsToRelate as _getPaymentsToRelate,
  saveRelatedPayments as _saveRelatedPayments,
} from '@/modules/shared/scholarship.api.js';

const STUDENT_PLACE_HOUR_DESC = 'Estudiante/Lugar y Hora';
const BROTHER_PLACE_HOUR_DESC = 'Hermanos/Lugar y Hora';

export default {
  name: 'PaymentRelationship',
  components: {
    IconView,
    CustomDropDown,
    ActionButton,
    CustomSeparator,
    CustomResultNotFound,
    CustomInput,
    CustomCheckboxSingleOption,
    Board,
  },
  mixins: [alertMixin],
  props: {
    assistanceSummaryId: {
      type: Number,
      required: true,
    },
    studentSieId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    filter: {
      reasonType: null,
      sieOrSsn: null,
    },
    result: {
      services: [],
      studentInfo: null,
    },
  }),
  computed: {
    serviceDescription() {
      return (serv) =>
        `<div class="color-secondary-6 font-14">Servicio: </div> 
         <div class="color-black font-16">${serv}</div>`;
    },
    relationTypes() {
      return [
        {
          id: relatedPaymentReasonTypes.EstudianteLugarHora,
          name: STUDENT_PLACE_HOUR_DESC,
        },
        {
          id: relatedPaymentReasonTypes.HermanosLugarHora,
          name: BROTHER_PLACE_HOUR_DESC,
        },
      ];
    },
    showFilter() {
      return (
        this.filter.reasonType?.id ===
        relatedPaymentReasonTypes.HermanosLugarHora
      );
    },
    studentBoardData() {
      return [
        [
          {
            label: 'SIE:',
            icon: 'fas fa-address-book',
            data: this.result.studentInfo?.studentSieId,
          },
          {
            label: 'Estudiante:',
            icon: 'fas fa-address-book',
            data: this.result.studentInfo?.studentFullName,
          },
          {
            label: 'Región:',
            icon: 'fas fa-map-marker-alt',
            data: this.result.studentInfo?.region,
          },
          {
            label: 'Estatus del Estudiante:',
            icon: 'fas fa-ballot-check',
            data: this.result.studentInfo?.status,
          },
          {
            label: 'Impedimento:',
            icon: 'fas fa-ballot-check',
            data: this.result.studentInfo?.studentImpediment ?? '-',
          },
        ],
      ];
    },
  },
  mounted() {
    //set default reason type
    this.filter.reasonType = {
      id: relatedPaymentReasonTypes.EstudianteLugarHora,
      name: STUDENT_PLACE_HOUR_DESC,
    };
  },
  methods: {
    async searchHandler() {
      if (this.showFilter) {
        const isValid = await this.$refs.paymentRelationshipForm.validate();
        if (!isValid) {
          this.ShowToast('Alerta', 'Información Incompleta', 'error');
          return;
        }
      }

      const studentSidIdOrSsn = this.showFilter
        ? this.filter.sieOrSsn
        : this.studentSieId;

      const searchResponse = await _getPaymentsToRelate(
        this.assistanceSummaryId,
        this.filter.reasonType?.id,
        studentSidIdOrSsn.toString().trim()
      ).catch((err) => {
        this.ShowToast('', err.response.data.message, 'error');
      });

      if (searchResponse) {
        this.result = searchResponse.data;
      } else {
        this.result = {
          services: [],
          studentInfo: null,
        };
      }
    },
    onRefresh() {
      this.$emit('on-refresh');
    },
    async onSave() {
      const assistanceSummaryIdList = this.result.services
        .filter((s) => s.selected)
        .map((s) => s.assistanceSummaryId);

      if (assistanceSummaryIdList.length == 0) {
        this.ShowToast(
          'Alerta',
          'Debe seleccionar al menos un servicio',
          'error'
        );
        return;
      }

      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea relacionar esta información al Pago del Estudiante?',
        'Sí',
        'No'
      );
      if (answer) {
        const assistanceSummaryIdList = this.result.services
          .filter((s) => s.selected)
          .map((s) => s.assistanceSummaryId);

        const { data: saveResponse } = await _saveRelatedPayments(
          this.assistanceSummaryId,
          assistanceSummaryIdList
        );
        if (saveResponse) {
          this.ShowToast(
            'Proceso Exitoso',
            'Relación de Pago realizado exitosamente. ',
            'success'
          );
          this.onRefresh();
          this.onCancel();
        }
      }
    },
    onCancel() {
      this.$emit('on-cancel');
    },
    preventCheck(item, itemIndex) {
      this.result = {
        ...this.result,
        services: this.result.services.map((x, index) => {
          if (index === itemIndex) {
            x.selected = false;
          }
          return x;
        }),
      };
      this.$refs.customCheckboxRef[0].checked = false;
    },
    onSelectServiceHandler(item, itemIndex) {
      if (
        item.peiAnalysisServiceId == serviceTypeEnum.educativo &&
        !item.isManualAssistanceFlag &&
        item.analyzedById == null
      ) {
        this.ShowToast(
          'Alerta',
          'El record Educativo Público debe estar marcado analizado para poder realizar la Relación de Pago.',
          'error'
        );
        this.preventCheck(item, itemIndex);
        return;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

.relation-field {
  max-width: 100%;
}

.sie-field {
  max-width: 100%;
}
::v-deep .custom-drop-down {
  .vs__dropdown-toggle {
    height: 38px !important;
  }
}

::v-deep .custom-single-option {
  .checkbox-container,
  .checkbox-word-container {
    background: map-get($colors, 'secondary-9');
    border: 3px solid map-get($colors, 'white');
  }

  .green-box {
    background: map-get($colors, 'green') !important;
    border: 3px solid map-get($colors, 'white');
    .color-secondary-6,
    .color-black {
      color: map-get($colors, 'white') !important;
    }
  }
}

@media only screen and (max-width: 768px) {
  .relation-field {
    max-width: 100% !important;
  }
  .sie-field {
    max-width: 100% !important;
  }
}
</style>
